/**
 * A light's three intensity, shadow intensity, specular amount and fog energy, from its Godot
 * energy, sign, shadow opacity, `light_specular` and `light_volumetric_fog_energy`, and the exposure
 * of its world.
 */
import { DIRECTIONAL_LIGHT_3D_DEFAULTS, LIGHT_3D_DEFAULTS } from '../../../../godot/scene/light';
import { useExposureFactor } from '../../../../r3f/environment/worldExposure';
import { LIGHT_INTENSITY_SCALE } from '../../../../r3f/lightConstants';
/** `light_energy` with the sign of `light_negative`, as Godot's light buffer holds it (`light_storage.cpp:646`). */
export function signedLightEnergy(properties) {
    return properties.light_negative === true ? -properties.light_energy : properties.light_energy;
}
/**
 * three's intensity: a negative light subtracts, in three as in Godot. The world's exposure scales
 * every light's energy as it fills the light buffer (`light_storage.cpp:656-658`, `:884-886`).
 *
 * @canonical A light's intensity under the exposure of its world
 */
export function useLightIntensity(properties) {
    return signedLightEnergy(properties) * LIGHT_INTENSITY_SCALE * useExposureFactor();
}
/** three's `shadow.intensity` mixes towards unshadowed as Godot's `shadow_opacity` does (`scene_forward_lights_inc.glsl:577`). */
export function lightShadowOpacity(properties) {
    return properties.shadow_opacity ?? LIGHT_3D_DEFAULTS.shadowOpacity;
}
/** An omni or spot light's `specular_amount`: twice its `light_specular` (`light_storage.cpp:891`). */
export function positionalLightSpecularAmount(properties) {
    return (properties.light_specular ?? LIGHT_3D_DEFAULTS.specular) * 2;
}
/** A directional light's specular amount: its `light_specular` itself (`light_storage.cpp:665`). */
export function directionalLightSpecularAmount(properties) {
    return properties.light_specular ?? DIRECTIONAL_LIGHT_3D_DEFAULTS.specular;
}
/** How strongly the light scatters into volumetric fog: its `light_volumetric_fog_energy`. */
export function lightFogEnergy(properties) {
    return properties.light_volumetric_fog_energy ?? LIGHT_3D_DEFAULTS.volumetricFogEnergy;
}
//# sourceMappingURL=lightStrength.js.map